import React from "react";
import PropTypes from "prop-types";
import { gql, useQuery } from "@apollo/client";
import TopbarViewerActions from "components/TopbarViewerActions";
import AccountMenu from "components/AccountMenu";
import { isSessionActive } from "lib/currentUser/session";

export const VIEWER_QUERY = gql`
  query ($path: String!) {
    viewer { role, user { id, avatar, name, newsFeedCount, hasAnalyticsAccess } }
    adminActions (path: $path) { icon, label, path, trackAction }
  }
`;

const TopbarDynamicContent = ({ path }) => {
  if (isSessionActive()) {
    const { loading, error, data } = useQuery(VIEWER_QUERY, {
      variables: { path },
    });

    if (loading) { return null; }
    if (error) { return null; }

    const adminActions = data.adminActions;
    const role = data.viewer.role;
    const user = data.viewer.user;

    return (
      <React.Fragment>
        <AccountMenu adminActions={adminActions} role={role} user={user} />
        <TopbarViewerActions adminActions={adminActions} role={role} user={user} />
      </React.Fragment>
    );
  }

  return (
    <TopbarViewerActions />
  );
};

TopbarDynamicContent.propTypes = {
  path: PropTypes.string.isRequired,
};

export default TopbarDynamicContent;
